import React, { useState } from 'react';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Button from 'components/buttons/Button';

import './WarehouseTable.scss';
import { WarehouseOrder } from '../WarehouseSystem';
import { groupBy } from '../../../components/OrderListTable/utils/groupBy';
import { arrayOfWarehouseLocations } from '../../../const/HubConfig';
import { ComboBoxComponent } from '../../../ReusableComponents/ComboBox/ComboBoxComponent';
import { ComboBoxItem } from '../../../ReusableComponents/ComboBox/ComboBoxComponent.types';

function countParcelsInCities(order: WarehouseOrder) {
  const groupByWarehouseLocation = groupBy(
    order.parcelIds.filter(obj => obj !== null),
    'warehouseLocation'
  );

  return Object.keys(groupByWarehouseLocation)
    .map(key => `${key}: ${groupByWarehouseLocation[key].length}`)
    .join(', ');
}

export const WarehouseTable = ({
  orders,
  deleteOrder,
}: {
  orders: WarehouseOrder[];
  deleteOrder: any;
}) => {
  const [selectedWarehouses, setWarehouses] = useState([]);
  const clickDeleteOrder = (orderId: string) => {
    Swal.fire({
      title: 'Danger zone!',
      text: `Are you sure you want to check out the order ${orderId}? This is a irreversible action. All the parcels for the orderId will be removed from the system. If  you are not sure. Scan them out with the Remove pacage scanner.`, // eslint-disable-line max-len
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Check out order',
      confirmButtonColor: '#d33',
      cancelButtonColor: '#ccc',
    })
      .then(result => {
        if (result.value) {
          deleteOrder(orderId);
        } else {
          Swal.fire('The order is safe!');
        }
      })
      .catch(error => console.error(error.message));
  };
  const filterWarehouses = (order: WarehouseOrder) => {
    if (selectedWarehouses.length === 0) return order;
    else {
      const copyOfOrder = Object.assign({}, order);
      copyOfOrder.parcelIds = copyOfOrder.parcelIds.filter(parcelWithLocation =>
        selectedWarehouses.includes(parcelWithLocation.warehouseLocation)
      );
      return copyOfOrder;
    }
  };

  const handleChange = (event, selectedValues: ComboBoxItem[]) =>
    setWarehouses(selectedValues.map(warehouse => warehouse.value));

  return (
    <>
      <div className="warehouse-table-filter">
        <ComboBoxComponent
          id="warehouse-filter"
          multiple
          comboBoxName="Filter warehouse"
          comboBoxItems={arrayOfWarehouseLocations(false, false).map(
            warehouse => ({ name: warehouse, value: warehouse })
          )}
          onChange={handleChange as any}
        />
      </div>
      <table className="warehouse-window-table">
        <thead>
          <tr>
            <th>OrderId</th>
            <th>Status</th>
            <th>Dev.</th>
            <th> Nr of Parcels</th>
            <th>Date</th>
            <th>Updated at</th>
            <th>Delivery Day</th>
            <th> Cities</th>
            <th className="ActionsHeader">Actions</th>
          </tr>
        </thead>
        <tbody>
          {orders.length > 0 ? (
            orders
              .sort((a, b) => dayjs(b.updatedAt).diff(dayjs(a.updatedAt)))
              .map(order => filterWarehouses(order))
              .map(
                order =>
                  order.parcelIds.length > 0 && (
                    <tr key={order.orderId}>
                      <td>
                        <Link
                          to={`/orders/${order.orderId}`}
                          className="link__clean"
                        >
                          {order.orderId}
                        </Link>
                      </td>
                      <td>{order.orderStatus}</td>
                      <td>{order.hasDeviations ? '\u2757' : ''}</td>
                      <td>{order.parcelIds.length}</td>
                      <td>{dayjs(order.createdAt).format('DD.MM')}</td>
                      <td>{dayjs(order.updatedAt).format('DD.MM')}</td>
                      <td>{dayjs(order.deliveryDay).format('DD.MM')}</td>
                      <td> {countParcelsInCities(order)}</td>
                      <td className="ActionsTable">
                        <Button
                          onClick={() => clickDeleteOrder(order.orderId)}
                          className="button muted-button"
                          title="CHECK OUT FROM WAREHOUSE"
                        />
                      </td>
                    </tr>
                  )
              )
          ) : (
            <tr>
              <td colSpan={5}>No orders</td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};
